import { Component } from "react";
import axios from "axios";

const objectToArray = (obj) => {
  const keys = Object.keys(obj);
  const res = [];
  for (let i = 0; i < keys.length; i++) {
    res.push([keys[i], obj[keys[i]]]);
  }
  return res;
};

const queryBTC =
  "https://api.coingecko.com/api/v3/simple/price?ids=bitcoin&vs_currencies=usd";
const queryDESO =
  "https://api.coingecko.com/api/v3/simple/price?ids=bitclout&vs_currencies=usd";

class Ticker extends Component {
  constructor() {
    super();

    this.state = {
      bitcoinusd: "",
      desousd: "",
    };
  }

  componentDidMount() {
    const updateB = async (queryURL) => {
      axios
        .get(queryURL)
        .then((response) => response.data)
        //   response.json())
        .then((data) =>
          this.setState(
            () => {
              // console.log(data);
              const wen = objectToArray(data);
              const price = wen[0][1].usd;
              if (queryURL === queryBTC) {
                return { bitcoinusd: price.toString() };
              } else {
                return { desousd: price.toString() };
              }
            },
            () => {
              console.log(this.state);
            }
          )
        );
    };
    updateB();
    // setInterval(updateB(queryBTC), 60000);
    setInterval(updateB(queryDESO), 60000);
  }

  render() {
    return (
      <div className="ticker-container">
        <span className="ticker">
          {/* <div>
            ₿ <span className="blink">:</span> $ {this.state.bitcoinusd}
          </div> */}
          <div>
            Ð <span className="blink">:</span> $ {this.state.desousd}
          </div>
        </span>
      </div>
    );
  }
}

export default Ticker;
